const DISABLE_MARK_RETURNED_ENUM = {
  RMA: 'RMA',
  NEW_STUDY: 'NEW_STUDY',
  ADMIN_TRANSFER: 'ADMIN_TRANSFER',
  ORG_TRANSFER: 'ORG_TRANSFER',
};

export { DISABLE_MARK_RETURNED_ENUM };
